import ModulePage from "../ModulePage/ModulePage";

const DesajustTitulacio = () => <ModulePage />;

export default DesajustTitulacio;
